/* Fetch all pd that is sent to IC with status, eg : status = pending, all pending analysis */
export class FetchPdListForIC {
  static readonly type = '[PdListForIC] GET'
  constructor(public payload: any) { }
}